import React from 'react';
import Component from '@vfuk/core-card-heading-and-icon-slot';
const CardHeadingAndIconSlot = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CardHeadingAndIconSlot;
